import React, { useState } from 'react';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { base64ToBlob, blobToFile, readCookie, createCookie } from '../../../utils/common';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { List, InputItem } from 'antd-mobile';
import { getQueryString } from '../../../utils/common';
import { updateNickname } from './action';
import { Toast } from 'antd-mobile';

import './index.scss';
const CopyrightEditor = props => {
	let history = useHistory();
	let dispatch = useDispatch();
	let title = decodeURIComponent(getQueryString('title') || '');
	// let token = readCookie('copyrighttoken');
	let nickname = readCookie('copyright_nickname');
	if (!nickname || nickname === 'null') {
		nickname = '';
	}
	let userId = readCookie('copyrightuserId');
	// let phone = readCookie('copyrightphone');
	// let avatar = readCookie('copyrightavatar');

	const [pageData, setPageData] = useState({
		nickname: nickname
	});

	function handleClickConfirm() {
		console.log(pageData.nickname);
		updateName();
	}

	function onBlurForIOS() {
		setTimeout(() => {
			window.scrollTo(0, 0);
		});
	}

	function handleNicknameChange(val) {
		pageData.nickname = val.target.value;
		setPageData({ ...pageData });
	}

	function updateName() {
		dispatch(
			updateNickname(
				{
					userId,
					nickname: pageData.nickname
				},
				data => {
					console.log('data', data);
					createCookie('copyright_nickname', pageData.nickname, 180);
					Toast.success('修改成功', 1, () => {
						window.location.href = '/vpmobile/copyright/setting';
					});
				},
				data => {
					console.log('error data', data);
				}
			)
		);
	}
	return (
		<div className="copyright copyright-setting">
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							history.goBack();
						}}>
						返回
					</label>
				</div>
				<span className="title">修改作者署名</span>
				<span className="confirm" onClick={handleClickConfirm}>
					确定
				</span>
			</header>
			<section className="main-content">
				<div className="set-container">
					<ul className="set-list">
						<li className="set-item tel">
							<input type="text" maxLength="20" value={pageData.nickname} onChange={handleNicknameChange} onBlur={onBlurForIOS} />
						</li>
					</ul>
				</div>
			</section>
		</div>
	);
};
export { CopyrightEditor };
